var Catalogos;
(function (Catalogos) {
    var Emisiones;
    (function (Emisiones) {
        class Copy {
            constructor(_dotNetObj) {
                this.dotNetObject = null;
                this.pasteLock = false;
                this.dotNetObject = _dotNetObj;
                this.inicializar();
            }
            inicializar() {
                Copy.HandleOnCopyRef = (e) => this.setHandleOnCopy(e);
                Copy.HandleOnPasteRef = (e) => this.setHandleOnPaste(e);
                Copy.HandleKeyUpRef = (e) => this.setKeyUp(e);
                document.addEventListener('copy', Copy.HandleOnCopyRef);
                document.addEventListener('paste', Copy.HandleOnPasteRef);
                document.addEventListener('keyup', Copy.HandleKeyUpRef);
            }
            setHandleOnCopy(e) {
                if (Utils.isEditableElement(e.target)) {
                    return;
                }
                this.dotNetObject.invokeMethodAsync('HandleOnCopy');
            }
            setHandleOnPaste(e) {
                if (Utils.isEditableElement(e.target)) {
                    return;
                }
                if (!this.pasteLock) {
                    this.pasteLock = true;
                    navigator.clipboard.readText().then((text) => {
                        this.dotNetObject.invokeMethodAsync('HandleOnPaste', text);
                    });
                }
            }
            setKeyUp(e) {
                var navegacion = [8, 9, 13, 27, 37, 38, 39, 40, 46];
                if (navegacion.indexOf(e.which) >= 0) {
                    e.preventDefault();
                }
                this.dotNetObject.invokeMethodAsync('HandleKeyUp', e.which);
            }
            clearPasteLock() {
                this.pasteLock = false;
            }
            setClipboardRows(_rows, _head) {
                let table = document.createElement('table');
                if (_head && _head.length > 0) {
                    var thead = document.createElement('thead');
                    for (var i = 0; i < _head.length; i++) {
                        var th = document.createElement('th');
                        th.style.fontWeight = 'bold';
                        th.style.backgroundColor = '#CCCCCC';
                        th.innerText = _head[i].title;
                        thead.appendChild(th);
                    }
                    table.appendChild(thead);
                }
                if (_rows && _rows.length > 0) {
                    let tbody = document.createElement('tbody');
                    let tbodyFragment = document.createDocumentFragment();
                    for (let i = 0; i < _rows.length; i++) {
                        let tr = document.createElement('tr');
                        for (let j = 0; j < _rows[i].cells.length; j++) {
                            let td = document.createElement('td');
                            td.innerText = _rows[i].cells[j].value;
                            tr.appendChild(td);
                        }
                        tbodyFragment.append(tr);
                    }
                    tbody.append(tbodyFragment);
                    table.appendChild(tbody);
                }
                let html = table.outerHTML;
                let blob = new Blob([html], { type: "text/html" });
                navigator.clipboard.write([new ClipboardItem({ [blob.type]: blob })]);
            }
            setClipboardValue(_value) {
                navigator.clipboard.writeText(_value);
            }
            dispose() {
                document.removeEventListener('copy', Copy.HandleOnCopyRef);
                document.removeEventListener('paste', Copy.HandleOnPasteRef);
                document.removeEventListener('keyup', Copy.HandleKeyUpRef);
            }
        }
        Copy.CurrentInstance = null;
        function crearCopy(_dotNetObj) {
            if (Copy.CurrentInstance) {
                Copy.CurrentInstance.dispose();
                delete Copy.CurrentInstance;
            }
            Copy.CurrentInstance = new Copy(_dotNetObj);
            return Copy.CurrentInstance;
        }
        Emisiones.crearCopy = crearCopy;
        function focusAndSelect(_id, _initialValue) {
            let element = document.getElementById(_id);
            if (element) {
                element.focus();
                if (_initialValue) {
                    element.value = _initialValue;
                }
                else {
                    element.select();
                }
            }
        }
        Emisiones.focusAndSelect = focusAndSelect;
    })(Emisiones = Catalogos.Emisiones || (Catalogos.Emisiones = {}));
})(Catalogos || (Catalogos = {}));
